import { log } from 'log';
import { compose, prop } from 'ramda';
import { require } from 'js/backbone/portlets';
import { useFormsSelector } from 'js/store/hooks';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { Loader } from 'js/components/common/Loader';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { componentService } from 'js/services/component.service';
import React, { useState, useEffect, useRef, memo } from 'react';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';
import { withPortlet, usePortletConfig } from 'js/components/system/Portlet';

import { REGISTRATION } from './constants';

import style from './Registration.scss';

const RegistrationWrapper = () => {
    const elRef = useRef();
    const registrationView = useRef();
    const isMounted = useIsMounted();
    const config = usePortletConfig();
    const [isError, setIsError] = useState(false);
    const isFormsLoaded = useFormsSelector(prop('isFormsLoaded'));

    useEffect(() => {
        if (!isFormsLoaded) {
            return;
        }

        require(['portlets_registration_registration_model'], (Model) => {
            try {
                const model = new Model({ config, ...config }, { parse: true });
                const view = model.getView();

                view.setElement(elRef.current).render();
                registrationView.current = view;
            } catch (error) {
                log('error', error);

                setIsError(true);
            }
        });
    }, [isFormsLoaded, config]);

    useEffect(() => () => {
        isMounted() && setIsError(false);
        registrationView?.current?.close();
    }, [isMounted]);

    if (!isFormsLoaded) {
        return <Loader />;
    }

    return (
        <div>
            {isError && (
                <ErrorMessage className={style.error} message="playtech.mobile.system.portlet.portletInitializingFailed" />
            )}
            <BackboneWrapper el={elRef} />
        </div>
    );
};

export const Registration = compose(
    memo,
    withPortlet()
)(RegistrationWrapper);

componentService.registerPageComponents({ [REGISTRATION]: Registration });
